/* =========================================================================
   Pure n' Bio · Food Supplement Bundle Landing
   bundle-landing-food.js
   Vanilla JS, no dependencies. Real Shopify cart via /cart/add.js + /cart.js.
   Dual threshold: 299 SAR (shipping) and 400 SAR (gift — pick one of two).
   ========================================================================= */

(function () {
  'use strict';

  var CFG = (typeof window !== 'undefined' && window.PnbfBundleConfig) || {};
  var THRESHOLD_SHIPPING = CFG.thresholdShipping || 299;
  var THRESHOLD_GIFT = CFG.thresholdGift || 400;
  var GIFT_PROP_KEY = '_gift';
  var GIFT_PROP_VALUE = 'food-supplement';
  var GIFT_SLOT_KEY = 'pnbf_gift_pick';
  var IS_RTL = !!CFG.isRtl || document.documentElement.dir === 'rtl' || !!document.querySelector('.pnbf-bundle.is-rtl');
  var SAR_HTML = CFG.sarHtml || (IS_RTL ? '<span class="pnbf-sar" aria-label="ريال"></span>' : '<span class="pnbf-sar" aria-label="SAR"></span>');

  var TABBY_LOGO_SVG = '<svg class="pnbf-tabby-logo" viewBox="22 70 168 72" role="img" aria-label="tabby" xmlns="http://www.w3.org/2000/svg" focusable="false"><path fill="#5AFEAE" d="M166.2,139.5H45.8c-11.6,0-20.9-9.4-20.9-20.9V93.5c0-11.6,9.4-20.9,20.9-20.9h120.4c11.6,0,20.9,9.4,20.9,20.9v25.1C187.1,130.1,177.8,139.5,166.2,139.5z"/><path fill="#292929" d="M157.9,94.1l-8.3,31.7l0,0.1h6.5l8.3-31.7H157.9z M55.3,112.1c-1,0.5-2,0.7-3.1,0.7c-2.3,0-3.6-0.4-3.8-2.3v-0.1c0-0.1,0-0.1,0-0.2v-5.5l0-0.6v-3.9h0v-1.6l0-0.6v-3.7L42.6,95c3.9-0.8,6.1-3.8,6.1-6.9v-1.9h-6.5v8.9l-0.4,0.1v16.4c0.2,4.6,3.3,7.4,8.2,7.4c1.8,0,3.7-0.4,5.2-1.1l0,0L55.3,112.1L55.3,112.1L55.3,112.1z M56.3,92.9l-18.2,2.8v4.6l18.2-2.8C56.3,97.5,56.3,92.9,56.3,92.9z M56.3,99.7l-18.2,2.8v4.4l18.2-2.8C56.3,104.1,56.3,99.7,56.3,99.7z M76.7,101.8c-0.3-5.1-3.5-8.2-8.7-8.2c-3,0-5.5,1.2-7.2,3.4c-1.7,2.2-2.6,5.4-2.6,9.3c0,3.9,0.9,7.1,2.6,9.3c1.7,2.2,4.2,3.3,7.2,3.3c5.2,0,8.4-3,8.7-8.2v7.7h6.5V94.2l-6.5,1L76.7,101.8L76.7,101.8z M77.1,106.3c0,4.5-2.4,7.5-6.1,7.5c-3.8,0-6.1-2.8-6.1-7.5c0-4.7,2.3-7.5,6.1-7.5c1.8,0,3.4,0.7,4.5,2.1C76.5,102.2,77.1,104.1,77.1,106.3C77.1,106.3,77.1,106.3,77.1,106.3z M102.1,93.6c-5.2,0-8.4,3-8.7,8.2V87.1l-6.5,1v30.3h6.5v-7.7c0.3,5.2,3.5,8.2,8.7,8.2c6.1,0,9.8-4.7,9.8-12.6S108.2,93.6,102.1,93.6z M99.2,113.8c-3.7,0-6.1-2.9-6.1-7.5c0-2.2,0.6-4.1,1.6-5.4c1.1-1.4,2.6-2.1,4.5-2.1c3.8,0,6.1,2.8,6.1,7.5C105.3,111,103,113.8,99.2,113.8L99.2,113.8z M129.5,93.6c-5.2,0-8.4,3-8.7,8.2V87.1l-6.5,1v30.3h6.5v-7.7c0.3,5.2,3.5,8.2,8.7,8.2c6.1,0,9.8-4.7,9.8-12.6S135.6,93.6,129.5,93.6L129.5,93.6z M126.6,113.8c-3.7,0-6.1-2.9-6.1-7.5c0-2.2,0.6-4.1,1.6-5.4c1.1-1.4,2.6-2.1,4.5-2.1c3.8,0,6.1,2.8,6.1,7.5C132.7,111,130.4,113.8,126.6,113.8L126.6,113.8z M139.3,94.1h6.9l5.6,24.3h-6.2C145.6,118.4,139.3,94.1,139.3,94.1z M169.7,96.6v-1.9h-0.8v-0.4h2.1v0.4h-0.8v1.9H169.7z M171.1,96.6v-2.4h0.8l0.4,1.1c0.1,0.3,0.2,0.4,0.2,0.5c0-0.1,0.1-0.2,0.2-0.5l0.4-1.1h0.8v2.4h-0.5v-1.9l-0.7,1.9h-0.5l-0.6-1.9v1.9L171.1,96.6L171.1,96.6z"/></svg>';

  // Cached cart state — refreshed from /cart.js on every mutation.
  var STATE = { cart: null, syncing: false };

  // ------------------------------------------------------------------------
  // L10N — widget suffix labels
  // ------------------------------------------------------------------------
  var L = IS_RTL ? {
    shippingSuffix: 'للحصول على شحن مجاني',
    giftSuffix: 'للحصول على هديتك المجانية',
    shippingDone: 'الشحن المجاني مُفعّل',
    giftDone: 'هديتك المجانية مُفعّلة',
  } : {
    shippingSuffix: 'to free shipping',
    giftSuffix: 'to your free gift',
    shippingDone: 'Free shipping unlocked',
    giftDone: 'Free gift unlocked',
  };

  // Brand rule: Pure n' Bio uses Western digits (299, 400, 36) — NOT Arabic-Indic.
  // Kept as a no-op shim so call sites don't need to change.
  function toArDigits(n) {
    return String(n);
  }

  // ------------------------------------------------------------------------
  // CART STATE — real Shopify cart via /cart.js + /cart/add.js + /cart/change.js
  // ------------------------------------------------------------------------
  function cartFetch() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (c) { STATE.cart = c; return c; });
  }

  function notifyThemeCartChanged() {
    // Tell the theme's cart-drawer + cart-bubble to re-fetch from /cart.js.
    // The theme's cart-drawer.js listens for "cart:refresh"; cart.js dispatches "cart:updated".
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: STATE.cart } }));
    } catch (e) { /* old browsers */ }
  }

  function cartAdd(items) {
    var arr = Array.isArray(items) ? items : [items];
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: arr })
    }).then(function (r) { return r.ok ? r.json() : r.json().then(function (j) { return Promise.reject(j); }); })
      .then(function (data) { notifyThemeCartChanged(); return data; });
  }

  function cartChange(payload) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) { notifyThemeCartChanged(); return data; });
  }

  function cartTotalSar(cart) {
    var c = cart || STATE.cart;
    if (!c) return 0;
    // Cart total_price comes in cents (SAR has 2 decimals on Shopify).
    return Math.round((c.total_price || 0) / 100);
  }

  function findGiftLineKey(cart) {
    var c = cart || STATE.cart;
    if (!c || !c.items) return null;
    for (var i = 0; i < c.items.length; i++) {
      var p = c.items[i].properties || {};
      if (p[GIFT_PROP_KEY] === GIFT_PROP_VALUE) return c.items[i].key;
    }
    return null;
  }

  // Build a Set of variant IDs currently in the cart, EXCLUDING the gift line
  // item (so the gift card itself doesn't get an "added" badge — it's bonus,
  // not a customer choice).
  function cartVariantSet(cart) {
    var c = cart || STATE.cart;
    var out = {};
    if (!c || !c.items) return out;
    for (var i = 0; i < c.items.length; i++) {
      var it = c.items[i];
      var props = it.properties || {};
      if (props[GIFT_PROP_KEY] === GIFT_PROP_VALUE) continue;
      out[String(it.variant_id)] = true;
    }
    return out;
  }

  // Mark every card with a data-variant-id matching a cart line item with
  // .is-added (and reflect on its add button if present). Runs after every
  // cart mutation so card state is consistent with reality, including the
  // case where the customer added via the quick-view modal.
  function syncCardsFromCart() {
    var inCart = cartVariantSet();
    var labelAdded = IS_RTL ? 'في المجموعة' : 'In bundle';
    var labelAdd = IS_RTL ? 'أضف' : 'Add';
    var nodes = document.querySelectorAll('.pnbf-pcard[data-variant-id], .pnbf-lifecard[data-handle], .pnbf-mini-card[data-handle]');
    nodes.forEach(function (card) {
      var vid = card.getAttribute('data-variant-id');
      if (!vid) {
        // Lifecards and mini-cards may only carry data-handle. Resolve via QV_CACHE.
        var handle = card.getAttribute('data-handle');
        var cached = handle ? QV_CACHE[handle] : null;
        var v = cached && cached.variants && cached.variants[0];
        vid = v ? String(v.id) : '';
      }
      var added = vid && inCart[vid];
      card.classList.toggle('is-added', !!added);
      var btn = card.querySelector('.pnbf-pcard-add');
      if (btn && !btn.disabled) {
        if (added) {
          if (!btn.dataset.origLabel) btn.dataset.origLabel = btn.textContent;
          btn.classList.add('is-added');
          btn.textContent = labelAdded;
        } else if (btn.classList.contains('is-added')) {
          btn.classList.remove('is-added');
          btn.textContent = btn.dataset.origLabel || labelAdd;
        }
      }
    });
  }

  function getPickedGiftVariantId() {
    try {
      var slot = sessionStorage.getItem(GIFT_SLOT_KEY);
      if (!slot) return null;
      var card = document.querySelector('.pnbf-gift-card[data-gift-slot="' + slot + '"]');
      if (!card) return null;
      var id = card.getAttribute('data-variant-id');
      return id ? Number(id) : null;
    } catch (e) { return null; }
  }

  // Reconcile gift line item with current cart total and selected slot.
  // Always re-fetches /cart.js first so the decision uses live state, not the
  // possibly-stale cached STATE.cart (e.g. after the customer edits the cart
  // in another drawer or tab).
  // - If total >= threshold and slot picked: ensure that gift variant is in cart with _gift property.
  // - Else: remove any existing gift line item.
  function syncGiftItem() {
    if (STATE.syncing) return Promise.resolve();
    STATE.syncing = true;
    var done = function () { STATE.syncing = false; };

    return cartFetch().then(function () {
      var total = cartTotalSar();
      var existingKey = findGiftLineKey();
      var targetVariant = (total >= THRESHOLD_GIFT) ? getPickedGiftVariantId() : null;

      // If existing item already matches the target variant, nothing to do.
      if (existingKey) {
        var existing = STATE.cart.items.find(function (it) { return it.key === existingKey; });
        if (existing && targetVariant && existing.variant_id === targetVariant) {
          return null;
        }
      }

      var p = Promise.resolve();
      if (existingKey) {
        p = p.then(function () { return cartChange({ id: existingKey, quantity: 0 }); }).then(function (c) { STATE.cart = c; });
      }
      if (targetVariant) {
        p = p.then(function () {
          var item = { id: targetVariant, quantity: 1, properties: {} };
          item.properties[GIFT_PROP_KEY] = GIFT_PROP_VALUE;
          return cartAdd(item);
        }).then(function () { return cartFetch(); });
      }
      return p;
    }).then(function () { renderWidget(); syncCardsFromCart(); done(); }).catch(function () { done(); });
  }

  // ------------------------------------------------------------------------
  // WIDGET UPDATE — paints the floating "Your Bundle" panel from real cart
  // ------------------------------------------------------------------------
  function renderWidget() {
    var total = cartTotalSar();
    var totalEl = document.getElementById('pnbf-widget-total');
    if (totalEl) totalEl.innerHTML = toArDigits(total) + ' ' + SAR_HTML;

    var shipRow = document.querySelector('.pnbf-widget-row[data-goal="shipping"]');
    var giftRow = document.querySelector('.pnbf-widget-row[data-goal="gift"]');
    var shipText = document.getElementById('pnbf-widget-shipping-text');
    var giftText = document.getElementById('pnbf-widget-gift-text');

    if (shipRow && shipText) {
      if (total >= THRESHOLD_SHIPPING) {
        shipRow.classList.add('is-unlocked');
        shipText.innerHTML = '<b>' + L.shippingDone + '</b>';
      } else {
        shipRow.classList.remove('is-unlocked');
        var remShip = THRESHOLD_SHIPPING - Math.round(total);
        shipText.innerHTML = '<b>' + toArDigits(remShip) + ' ' + SAR_HTML + '</b>&nbsp;' + L.shippingSuffix;
      }
    }

    if (giftRow && giftText) {
      if (total >= THRESHOLD_GIFT) {
        giftRow.classList.add('is-unlocked');
        giftText.innerHTML = '<b>' + L.giftDone + '</b>';
      } else {
        giftRow.classList.remove('is-unlocked');
        var remGift = THRESHOLD_GIFT - Math.round(total);
        giftText.innerHTML = '<b>' + toArDigits(remGift) + ' ' + SAR_HTML + '</b>&nbsp;' + L.giftSuffix;
      }
    }
  }

  // ------------------------------------------------------------------------
  // STACK + CARD ADD-TO-CART (real Shopify cart)
  // ------------------------------------------------------------------------
  function flashAdded(btn, errored) {
    var orig = btn.dataset.origLabel || btn.textContent;
    btn.dataset.origLabel = orig;
    btn.textContent = errored
      ? (IS_RTL ? '⚠ غير متاح' : '⚠ Unavailable')
      : (IS_RTL ? '✓ أُضيف' : '✓ Added');
    setTimeout(function () { btn.textContent = orig; }, 1600);
  }

  function handleAddClick(e) {
    var btn = e.target.closest('.pnbf-stack-add, .pnbf-pcard-add');
    if (!btn) return;

    // If the button is a scroll-to trigger, let the other handler take it.
    if (btn.hasAttribute('data-scroll-to')) return;

    // Don't try to add placeholder / "coming soon" cards
    if (btn.closest('.pnbf-pcard-soon')) return;

    // If it's a stack "view stack" CTA card (the cross-sell card in joints/api), scroll to stacks.
    if (btn.closest('.pnbf-pcard-stack')) {
      var target = document.getElementById('pnbf-stacks');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    e.preventDefault();
    if (btn.disabled) return;

    // Stack add: button has data-variant-ids="id1,id2,id3"
    var stackIds = btn.getAttribute('data-variant-ids');
    var items;
    if (stackIds) {
      items = stackIds.split(',').map(function (s) { return s.trim(); }).filter(Boolean).map(function (id) {
        return { id: Number(id), quantity: 1 };
      });
      if (!items.length) return;
    } else {
      // Single-product add: button has data-variant-id="id"
      var single = btn.getAttribute('data-variant-id');
      if (!single) return;
      items = [{ id: Number(single), quantity: 1 }];
    }

    btn.disabled = true;
    cartAdd(items)
      .then(function () { return cartFetch(); })
      .then(function () { return syncGiftItem(); })
      .then(function () { renderWidget(); syncCardsFromCart(); flashAdded(btn, false); })
      .catch(function () { flashAdded(btn, true); })
      .then(function () { btn.disabled = false; });
  }

  // ------------------------------------------------------------------------
  // QUICK-VIEW MODAL
  // Clicking any .pnbf-lifecard[data-handle] opens an in-page quick view
  // with image carousel, title, price, stock state, description, and an
  // Add-to-Bundle CTA. Product data fetched from /products/{handle}.js.
  // Out-of-stock products render the modal with the sold-out state and
  // disable the CTA.
  // ------------------------------------------------------------------------
  var QV_CACHE = {};
  var QV_STATE = { images: [], index: 0, product: null };

  function qvLabels() {
    return IS_RTL ? {
      in_stock: 'متوفر',
      out_of_stock: 'نفذت الكمية',
      loading: 'جارٍ التحميل…',
      added: '\u2713 أُضيف إلى المجموعة'
    } : {
      in_stock: 'In stock',
      out_of_stock: 'Sold out',
      loading: 'Loading…',
      added: '\u2713 Added to bundle'
    };
  }

  function qvOpen() {
    var m = document.getElementById('pnbf-qv-modal');
    if (!m) return;
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pnbf-modal-open');
  }

  function qvClose() {
    var m = document.getElementById('pnbf-qv-modal');
    if (!m) return;
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pnbf-modal-open');
  }

  function qvRenderCarousel() {
    var track = document.getElementById('pnbf-qv-track');
    var dots = document.getElementById('pnbf-qv-dots');
    if (!track) return;
    track.innerHTML = '';
    dots.innerHTML = '';
    QV_STATE.images.forEach(function (src, i) {
      var slide = document.createElement('div');
      slide.className = 'pnbf-qv-slide';
      var img = document.createElement('img');
      img.src = src;
      img.loading = 'lazy';
      img.alt = '';
      slide.appendChild(img);
      track.appendChild(slide);

      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'pnbf-qv-dot';
      dot.setAttribute('data-i', String(i));
      dot.setAttribute('aria-label', String(i + 1));
      dots.appendChild(dot);
    });
    qvGoTo(0);
  }

  function qvGoTo(i) {
    if (!QV_STATE.images.length) return;
    if (i < 0) i = QV_STATE.images.length - 1;
    if (i >= QV_STATE.images.length) i = 0;
    QV_STATE.index = i;
    var track = document.getElementById('pnbf-qv-track');
    if (track) {
      var offset = IS_RTL ? (i * 100) : (-i * 100);
      track.style.transform = 'translateX(' + offset + '%)';
    }
    var dots = document.querySelectorAll('#pnbf-qv-dots .pnbf-qv-dot');
    dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
  }

  function qvPopulate(p) {
    var L = qvLabels();
    var brandEl = document.getElementById('pnbf-qv-brand');
    var titleEl = document.getElementById('pnbf-qv-title');
    var priceEl = document.getElementById('pnbf-qv-price');
    var stockEl = document.getElementById('pnbf-qv-stock');
    var descEl = document.getElementById('pnbf-qv-desc');
    var addBtn = document.getElementById('pnbf-qv-add');

    if (brandEl) brandEl.textContent = p.vendor || '';
    if (titleEl) titleEl.textContent = p.title || '';

    var v = (p.variants && p.variants[0]) || {};
    var priceCents = (v.price || p.price || 0);
    var priceNum = Math.round(priceCents / 100);
    if (priceEl) priceEl.innerHTML = '<b>' + priceNum + '</b> ' + SAR_HTML;

    var tabbyEl = document.getElementById('pnbf-qv-tabby');
    if (tabbyEl) {
      var splitNum = Math.round(priceCents / 4) / 100;
      var splitStr = (splitNum % 1 === 0) ? String(splitNum) : splitNum.toFixed(2);
      tabbyEl.innerHTML = TABBY_LOGO_SVG + ' 4 \u00D7 <b>' + splitStr + '</b> ' + SAR_HTML;
    }

    var available = !!v.available;
    if (stockEl) {
      stockEl.textContent = available ? L.in_stock : L.out_of_stock;
      stockEl.classList.toggle('is-soldout', !available);
    }

    // Strip HTML from description (first ~500 chars)
    if (descEl) {
      var tmp = document.createElement('div');
      tmp.innerHTML = p.description || '';
      var text = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
      if (text.length > 600) text = text.substring(0, 600).replace(/\s\S*$/, '') + '…';
      descEl.textContent = text;
    }

    // Normalize image URLs (Shopify sometimes returns protocol-relative //cdn...)
    QV_STATE.images = (p.images || []).map(function (s) {
      if (!s) return s;
      return s.indexOf('//') === 0 ? 'https:' + s : s;
    });
    if (!QV_STATE.images.length && p.featured_image) QV_STATE.images = [p.featured_image];

    QV_STATE.product = p;
    qvRenderCarousel();

    if (addBtn) {
      addBtn.disabled = !available;
      addBtn.classList.toggle('is-disabled', !available);
      addBtn.textContent = available
        ? (IS_RTL ? 'أضف إلى المجموعة' : 'Add to bundle')
        : L.out_of_stock;
      addBtn.dataset.handle = p.handle || '';
      addBtn.dataset.variantId = v.id || '';
      addBtn.dataset.price = priceNum;
      addBtn.dataset.title = p.title || '';
      addBtn.dataset.image = QV_STATE.images[0] || '';
    }

    var moreLink = document.getElementById('pnbf-qv-more');
    if (moreLink && p.handle) {
      var localePrefix = IS_RTL ? '/ar' : '';
      moreLink.href = localePrefix + '/products/' + p.handle;
    }
  }

  function qvShowLoading() {
    var L = qvLabels();
    var titleEl = document.getElementById('pnbf-qv-title');
    var priceEl = document.getElementById('pnbf-qv-price');
    var stockEl = document.getElementById('pnbf-qv-stock');
    var descEl = document.getElementById('pnbf-qv-desc');
    var brandEl = document.getElementById('pnbf-qv-brand');
    var track = document.getElementById('pnbf-qv-track');
    if (brandEl) brandEl.textContent = '';
    if (titleEl) titleEl.textContent = L.loading;
    if (priceEl) priceEl.textContent = '';
    var tabbyEl = document.getElementById('pnbf-qv-tabby');
    if (tabbyEl) tabbyEl.textContent = '';
    if (stockEl) { stockEl.textContent = ''; stockEl.classList.remove('is-soldout'); }
    if (descEl) descEl.textContent = '';
    if (track) track.innerHTML = '';
  }

  function qvLoad(handle) {
    if (!handle) return;
    qvShowLoading();
    qvOpen();
    if (QV_CACHE[handle]) { qvPopulate(QV_CACHE[handle]); return; }
    var localePrefix = IS_RTL ? '/ar' : '';
    fetch(localePrefix + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (p) { QV_CACHE[handle] = p; qvPopulate(p); })
      .catch(function () {
        var titleEl = document.getElementById('pnbf-qv-title');
        if (titleEl) titleEl.textContent = IS_RTL ? 'تعذّر التحميل' : 'Could not load product';
      });
  }

  function handleLifecardClick(e) {
    var card = e.target.closest('.pnbf-lifecard[data-handle]');
    if (!card) return;
    e.preventDefault();
    qvLoad(card.getAttribute('data-handle'));
  }

  function handleMiniCardClick(e) {
    var card = e.target.closest('.pnbf-mini-card[data-handle]');
    if (!card) return;
    e.preventDefault();
    qvLoad(card.getAttribute('data-handle'));
  }

  function handlePcardClick(e) {
    // Regular band product cards (NOT stack/placeholder cards) → open quick view.
    if (e.target.closest('button, a')) return;
    var card = e.target.closest('.pnbf-pcard[data-handle]:not(.pnbf-pcard-stack):not(.pnbf-pcard-soon)');
    if (!card) return;
    qvLoad(card.getAttribute('data-handle'));
  }

  function handleStackBottleClick(e) {
    // Bottle thumbnails inside a stack card → open quick view for that product.
    var bottle = e.target.closest('.pnbf-stack-bottle[data-handle]');
    if (!bottle) return;
    e.preventDefault();
    qvLoad(bottle.getAttribute('data-handle'));
  }

  function handleQvAdd(e) {
    var btn = e.target.closest('#pnbf-qv-add');
    if (!btn || btn.disabled) return;
    var variantId = Number(btn.dataset.variantId || 0);
    if (!variantId) return;
    var L = qvLabels();
    var orig = btn.textContent;
    btn.disabled = true;
    cartAdd({ id: variantId, quantity: 1 })
      .then(function () { return cartFetch(); })
      .then(function () { return syncGiftItem(); })
      .then(function () {
        renderWidget();
        syncCardsFromCart();
        btn.textContent = L.added;
        btn.classList.add('is-added');
      })
      .catch(function () {
        btn.textContent = IS_RTL ? '⚠ تعذّر الإضافة' : '⚠ Could not add';
      })
      .then(function () {
        btn.disabled = false;
      });
    setTimeout(function () {
      btn.textContent = orig;
      btn.classList.remove('is-added');
      qvClose();
    }, 900);
  }

  function handleQvControl(e) {
    if (e.target.closest('.pnbf-modal-close') || e.target.classList.contains('pnbf-modal-backdrop')) {
      qvClose();
      return;
    }
    if (e.target.closest('.pnbf-qv-prev')) { qvGoTo(QV_STATE.index - 1); return; }
    if (e.target.closest('.pnbf-qv-next')) { qvGoTo(QV_STATE.index + 1); return; }
    var dot = e.target.closest('.pnbf-qv-dot');
    if (dot) { qvGoTo(parseInt(dot.getAttribute('data-i'), 10)); return; }
  }

  function handleEscape(e) {
    if (e.key !== 'Escape') return;
    var m = document.getElementById('pnbf-qv-modal');
    if (m && m.classList.contains('is-open')) qvClose();
  }

  // ------------------------------------------------------------------------
  // STOCK STATUS PASS — on page load, fetch availability for every card
  // that declares a data-handle. Out-of-stock cards get the .is-soldout
  // class which reveals the "Sold out" sticker and mutes the visuals.
  // Uses QV_CACHE so a subsequent quick-view doesn't re-fetch.
  // ------------------------------------------------------------------------
  function markSoldOut() {
    var nodes = document.querySelectorAll('[data-handle]');
    var byHandle = {};
    nodes.forEach(function (el) {
      var h = el.getAttribute('data-handle');
      if (!h) return;
      if (!byHandle[h]) byHandle[h] = [];
      byHandle[h].push(el);
    });
    var localePrefix = IS_RTL ? '/ar' : '';
    Object.keys(byHandle).forEach(function (handle) {
      var els = byHandle[handle];
      var cached = QV_CACHE[handle];
      if (cached) { applyStock(els, cached); return; }
      fetch(localePrefix + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          QV_CACHE[handle] = p;
          applyStock(els, p);
        })
        .catch(function () { /* network flake — leave card as-is */ });
    });
  }

  function applyStock(els, product) {
    var v = (product.variants && product.variants[0]) || {};
    var available = !!v.available;
    els.forEach(function (el) {
      el.classList.toggle('is-soldout', !available);
    });
  }

  // ------------------------------------------------------------------------
  // GIFT PICKER — mutually exclusive single-select.
  // Persists slot, then reconciles cart: if total >= 400 and slot has a
  // resolvable variant, it's added with properties[_gift]=food-supplement.
  // ------------------------------------------------------------------------
  function handleGiftClick(e) {
    var card = e.target.closest('.pnbf-gift-card');
    if (!card) return;
    var parent = card.parentElement;
    if (!parent) return;
    parent.querySelectorAll('.pnbf-gift-card').forEach(function (c) { c.classList.remove('is-selected'); });
    card.classList.add('is-selected');

    // Persist which slot the customer picked (propolis | hydrogen).
    var slot = card.getAttribute('data-gift-slot') || '';
    try { sessionStorage.setItem(GIFT_SLOT_KEY, slot); } catch (err) { /* no-op */ }

    // Reconcile gift line item with the new selection.
    syncGiftItem();
  }

  // ------------------------------------------------------------------------
  // SCROLL-TO — any element with data-scroll-to="id"
  // ------------------------------------------------------------------------
  function handleScrollTo(e) {
    var btn = e.target.closest('[data-scroll-to]');
    if (!btn) return;
    var targetId = btn.getAttribute('data-scroll-to');
    if (!targetId) return;
    var el = document.getElementById(targetId);
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ------------------------------------------------------------------------
  // CONCERN PANELS — click a tile, expand inline panel, close via button
  // ------------------------------------------------------------------------
  function closeAllConcernPanels() {
    document.querySelectorAll('.pnbf-concern-panel').forEach(function (p) { p.hidden = true; });
    document.querySelectorAll('.pnbf-tile[data-concern]').forEach(function (t) {
      t.classList.remove('is-active');
      t.setAttribute('aria-expanded', 'false');
    });
  }

  function handleConcernTile(e) {
    var tile = e.target.closest('.pnbf-tile[data-concern]');
    if (!tile) return;
    e.preventDefault();
    var key = tile.getAttribute('data-concern');
    var panel = document.getElementById('pnbf-panel-' + key);
    if (!panel) return;
    var wasOpen = !panel.hidden;
    closeAllConcernPanels();
    if (!wasOpen) {
      panel.hidden = false;
      tile.classList.add('is-active');
      tile.setAttribute('aria-expanded', 'true');
      // Smooth-scroll the panel into view without losing the grid above
      panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function handleConcernClose(e) {
    var btn = e.target.closest('.pnbf-panel-close');
    if (!btn) return;
    e.preventDefault();
    closeAllConcernPanels();
    var anchor = document.getElementById('pnbf-concerns');
    if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ------------------------------------------------------------------------
  // FAQ accordion (visible 3 + open/close toggle)
  // The <details> element handles the "See more" expand natively.
  // ------------------------------------------------------------------------
  function handleFaqClick(e) {
    var q = e.target.closest('.pnbf-faq-q');
    if (!q) return;
    var item = q.closest('.pnbf-faq-item');
    if (!item) return;
    item.classList.toggle('is-open');
  }

  // ------------------------------------------------------------------------
  // WIDGET toggle (mobile compact mode)
  // ------------------------------------------------------------------------
  function handleWidgetToggle() {
    var w = document.getElementById('pnbf-widget');
    if (!w) return;
    w.classList.toggle('is-collapsed');
  }

  function handleWidgetCta() {
    // Take the customer to their cart so they can review and check out.
    var localePrefix = IS_RTL ? '/ar' : '';
    window.location.href = localePrefix + '/cart';
  }

  // ------------------------------------------------------------------------
  // INIT
  // ------------------------------------------------------------------------
  function init() {
    // Restore gift slot UI selection from prior session, if any.
    try {
      var savedSlot = sessionStorage.getItem(GIFT_SLOT_KEY);
      if (savedSlot) {
        var savedCard = document.querySelector('.pnbf-gift-card[data-gift-slot="' + savedSlot + '"]');
        if (savedCard) savedCard.classList.add('is-selected');
      }
    } catch (e) { /* no-op */ }

    // Fetch real Shopify cart, paint widget, then reconcile gift item if needed.
    cartFetch()
      .then(function () { renderWidget(); syncCardsFromCart(); return syncGiftItem(); })
      .catch(function () { /* widget will show defaults */ renderWidget(); });

    markSoldOut();

    document.addEventListener('click', function (e) {
      handleConcernClose(e);
      handleConcernTile(e);
      handleScrollTo(e);
      handleLifecardClick(e);
      handleMiniCardClick(e);
      handlePcardClick(e);
      handleStackBottleClick(e);
      handleQvControl(e);
      handleQvAdd(e);
      handleAddClick(e);
      handleGiftClick(e);
      handleFaqClick(e);
    });
    document.addEventListener('keydown', handleEscape);

    var toggleBtn = document.getElementById('pnbf-widget-toggle');
    if (toggleBtn) toggleBtn.addEventListener('click', handleWidgetToggle);

    var ctaBtn = document.getElementById('pnbf-widget-cta');
    if (ctaBtn) ctaBtn.addEventListener('click', handleWidgetCta);

    initTopbarRotator();
    initTopbarSticky();

    // Mark this session as "bundle-active" so other pages on the storefront can
    // render a sticky 'back to bundle' banner. See layout/theme.liquid.
    // Most-recent-visit wins: clear any other bundle's active flags so only the
    // food banner is rendered on subsequent product pages this session. Also
    // reset food's own dismiss flag so a re-visit re-shows the banner.
    try {
      sessionStorage.removeItem('pnb_baby_bundle_active');
      sessionStorage.removeItem('pnb_baby_bundle_path');
      sessionStorage.removeItem('pnb_baby_btb_dismissed');
      sessionStorage.removeItem('pnbf_btb_dismissed');
      sessionStorage.setItem('pnbf_food_bundle_active', '1');
      sessionStorage.setItem('pnbf_food_bundle_path', IS_RTL ? '/ar/pages/food-supplement-bundle' : '/pages/food-supplement-bundle');
    } catch (e) { /* private browsing — no-op */ }
  }

  function initTopbarSticky() {
    var bar = document.querySelector('[data-pnbf-topbar]');
    if (!bar) return;
    // Find the sticky theme header. Prefer the named class; fall back to the
    // first sticky/fixed element near the top of the page.
    var hdr = document.querySelector('.f-section-header');
    if (!hdr) {
      var stickyCandidates = document.querySelectorAll('header, .header, .shopify-section-group-header-group, .shopify-section-header');
      for (var i = 0; i < stickyCandidates.length; i++) {
        var cs = getComputedStyle(stickyCandidates[i]);
        if ((cs.position === 'sticky' || cs.position === 'fixed') && stickyCandidates[i].offsetHeight > 40) {
          hdr = stickyCandidates[i];
          break;
        }
      }
    }
    if (!hdr) return;
    var update = function () {
      var h = hdr.offsetHeight || 0;
      bar.style.setProperty('--pnbf-topbar-top', h + 'px');
    };
    update();
    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) {
      try { new ResizeObserver(update).observe(hdr); } catch (e) { /* no-op */ }
    }
  }

  function initTopbarRotator() {
    var bar = document.querySelector('[data-pnbf-topbar]');
    if (!bar || bar.dataset.rotatorInit === '1') return;
    var msgs = bar.querySelectorAll('.pnbf-topbar-msg');
    if (msgs.length < 2) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    bar.dataset.rotatorInit = '1';
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
